import React from 'react';
import CustomState from './CustomState';
import { baseStatePropTypes } from './baseStatePropTypes';
var ErrorState = function ErrorState(props) {
  return /*#__PURE__*/React.createElement(CustomState, props);
};
ErrorState.defaultProps = {
  icon: 'rioglyph-truck-breakdown'
};
ErrorState.propTypes = baseStatePropTypes;
export default ErrorState;